
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("modal/snack",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"fw-snack\" data-fw-onclick=\"snackclose\" style=\"background-color: #24B569\"><icon>"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_checkmark_circle",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":91},"end":{"line":1,"column":124}}}))
    + "</icon> "
    + container.escapeExpression(lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"key") : depth0),{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":132},"end":{"line":1,"column":144}}}))
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"html") : depth0), depth0)) != null ? stack1 : "")
    + " </div>";
},"useData":true});
export default TPL;